// extracted by mini-css-extract-plugin
export var overviewPriceContainer = "index-module--overviewPriceContainer--2Axie";
export var overviewLabel = "index-module--overviewLabel--2axiZ";
export var divider = "index-module--divider--2vZyk";
export var mobileContainer = "index-module--mobileContainer--36ZAV";
export var policy = "index-module--policy--3bAWM";
export var modalPrice = "index-module--modalPrice--TgBda";
export var addToCartButton = "index-module--addToCartButton--1sYqG";
export var flybusLogo = "index-module--flybusLogo--1DiTj";